export default __webpack_public_path__ + "static/media/one-point-jump.fd8f48b1.md";